/* eslint-disable class-methods-use-this */
import React from 'react';
import { useRouteData, useSiteData, Head } from 'react-static';
// template components
import Page from '@nmx/template/dist/componentLibrary/layout/Page';
// native components
import UnitVals from './components/unitvals';

export default () => {
  const { config, dynamicConfig } = useSiteData();
  const { pageProps } = useRouteData();

  return (
    <Page
      {...pageProps} // defined in route.js
      headComponent={Head}
      dynamicConfig={dynamicConfig}
      config={config}
      disableDisclaimerTopBorder={false}
      breadcrumbsNavigationConfig={[
        {
          pageName: 'Home',
          linkUrl: '/',
          linkAriaLabel: 'Northwestern Mutual Home',
        },
        {
          pageName: 'Fixed Variable Annuities',
          linkUrl: '/annuities/',
          linkAriaLabel: 'Northwestern Mutual Income Annuities',
        },
        {
          pageName: 'Daily Unit Values',
          linkUrl: '/annuities/daily-unit-values/',
          linkAriaLabel: 'Northwestern Mutual Daily Unit Values',
        },
        {
          pageName: 'Deferred Annuities',
          linkUrl: '/fixed-annuity-vs-variable-annuity/daily-unit-values/daily-unit-values-deferred-annuities/',
          linkAriaLabel: 'Northwestern Mutual Daily Unit Values Deferred Annuities',
        },
      ]}
      customDisclaimers={[
        <>
          Mason Street Advisors, LLC &#40;MSA&#41; is the principal investment adviser for all the Portfolios in the Northwestern Mutual Series Fund &#40;Series Fund&#41;. &#40;Portfolios in the Series Fund are identified by the parenthetical next to the portfolio name.&#41; MSA has engaged and oversees sub&#45;advisers who provide day&#45;to&#45;day management for certain of the Series Fund Portfolios. Each sub&#45;adviser may be replaced without the approval of shareholders. Please see the prospectus or summary prospectus for more information. Additional fund options are advised by Russell Investments, Fidelity Investments, Neuberger Berman Investment Advisers LLC and UBS Asset Management (Americas) LLC.
        </>,
        <>
          Past performance is not a guarantee of future results.
        </>,
        <>
          <strong>For more complete information please refer to the prospectus or summary prospectus which you can obtain from your Northwestern Mutual Investment Services Registered Representative. Read the prospectus and summary prospectus carefully and consider the investment objectives, risks, and charges and expenses carefully before you invest or send money.</strong>
        </>,
        <>
          Issuer: The Northwestern Mutual Life Insurance Company, 720 E. Wisconsin Avenue, Milwaukee, WI 53202&#45;4797
        </>,
        <>
          Principal Underwriter: <strong>Northwestern Mutual Investment Services, LLC</strong> &#40;NMIS&#41; &#40;investment brokerage services&#41;, subsidiary of NM, registered investment adviser, broker&#45;dealer, member FINRA and SIPC.
        </>,
      ]}>

      <UnitVals />

    </Page>
  );
};
